import { render, staticRenderFns } from "./MyCoursesDesktop.vue?vue&type=template&id=6af298c6&scoped=true"
import script from "./MyCoursesDesktop.vue?vue&type=script&lang=js"
export * from "./MyCoursesDesktop.vue?vue&type=script&lang=js"
import style0 from "./MyCoursesDesktop.vue?vue&type=style&index=0&id=6af298c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af298c6",
  null
  
)

export default component.exports